module.exports = __webpack_public_path__ + "static/media/1023787.a34885c5.png";